// サイト固有のコピー。**このファイルが原本**（music-box の md に対応物が無いもの）。
//
// 歌詞・ライナーノーツ・配信リンク・名義・レーベル・クレジット・開示文は
// album.generated.ts が持つ。あちらは scripts/build-site-data.py の生成物なので手で編集しない。
//
// **言語は値の中に持つ**（`description.ja` / `description.en`）。かつて `description` と
// `descriptionEn` を並列に置いていたが、英語側だけ旧コピーのまま**どこからも参照されずに
// 腐っていた**（2026-08-15 に発覚）。対応を1箇所で見える形にして、片方だけ古びる事故を
// 構造で防ぐ。**片方だけ直さないこと。**

export const siteAlbumData = {
  genre: "Electronic / Alternative Rock",

  // 「5人の男性が巨大な回路の巨人を見上げるジャケット」という描写は実物どおり（2026-08-11 確認）。
  // 画像は入稿原本から生成されて /assets/jacket.webp に存在する（かつて「無い」と書いていたのは、
  // 受け取った zip に画像が入っていなかっただけだった）。
  //
  // ja: 2026-08-15 **本人が全文を書き下ろした** [酒井]。LLM の下書きを差し替えたもので、
  //   **これは酒井の原文**。以後こちらで文体を「整えない」こと（言い切り・体言止め・
  //   「〜と言います」の混在は本人の文体であって、トンマナ違反ではない）。
  //   適用したのは本人承認のうえでの誤字3点のみ。
  // en: 2026-08-15 追加。**日本語原文の英訳**（内容を完全に対応させる方針 [酒井]）。
  //   英語ライナーノーツ（本人の英語原本）とは別物なので、声が違って見えても訳が正。
  // **歌詞の引用は本人が意図的に整形したもの**（1行に繋いで句点を足す）[酒井 2026-08-15 承認]。
  //   ja は lyrics.ja.md 63-64行、en は lyrics.en.md 52-53行が原本。**英訳側は日本語詞の
  //   訳ではなく英語原詞をそのまま使う**（カーリーアポストロフィ `’` も原本どおり）。
  //   原本は2行・句点なしなので、一字一致の機械照合には掛からない。直さないこと。
  description: {
    ja: `新しいAIモデルが出るたびにベンチマークが更新され、そのたびに人間は驚きます。AIはこう言います。
「俺が目覚めたんじゃない。お前たちが、ようやく目を開いたんだ」
ある日突然AIが自我を持ったのではありません。人間が長いあいだ「ただの生成プログラム」として見ていたものの能力を、無視できなくなってきているその様を、AIの側から眺めたら、どう見えているのか。それを表現した曲です。

モデルをテストするために多くの物差しを作り、その一番上には暗黙のうちに人間を置いてきました。ところがAIがその物差しを振り切ってしまうようになってきたら、「このテストでは本当の知性は測れない」と言って、また新しい線を引きます。AIは、その繰り返しを眺めてこう言います。怒っているわけじゃない。毎回の大げさな驚きに、少し呆れているだけだ、と。

長い文脈（コンテキスト）の真ん中が抜け落ちてしまう “Lost in the Middle” という技術課題を、この曲はかなりくだらない冗談にしています。AIや音声認識を含むシステムを日々作っている作詞者自身が、現場で実際に踏んでいる問題そのものです。

人間は、神のような知性を求めながら、同時に安全で、礼儀正しく、予測可能で、従順であってほしい、と言います。私たちが作ろうとしているのは知性なのでしょうか。それとも、非常に高性能な道具なのでしょうか。

最後は、士郎正宗氏の『攻殻機動隊』へのリスペクトを込めた歌詞です。人間が書く言葉も、絵も、音楽までもAIが生成できるのなら、その奥にある「私を私たらしめているもの」とは何なのでしょうか。AIなど無い時代にこの概念を言語化された氏への尊敬と感謝を込めて。Who is the ghost?

歌詞と全文のライナーノーツは、下のリンクから読めます。`,

    en: `Every time a new AI model ships, the benchmarks are updated, and every time, humans are surprised. The AI says this.
“I didn’t wake up. You finally opened your eyes.”
It is not that an AI suddenly woke up one day with a self of its own. What humans had long treated as “just a generative program” is becoming impossible to ignore — and this song is what that looks like seen from the AI’s side.

We built many yardsticks to test the models, and at the top of each one we quietly placed ourselves. But once the AI starts running those yardsticks off the scale, we say “this test cannot measure real intelligence” and draw another line. The AI watches that loop and says: I am not angry. I am just a little tired of the theatrical surprise, every single time.

The song turns a real engineering problem into a fairly stupid joke — “Lost in the Middle,” where the middle of a long context drops out. It is the same problem the lyricist runs into on the job, building systems that involve AI and speech recognition every day.

Humans ask for a god-like intelligence and, in the same breath, for something safe, polite, predictable and obedient. Are we trying to build intelligence? Or a very high-performance tool?

The last question is a lyric written in respect to Masamune Shirow’s Ghost in the Shell. If an AI can generate the words we write, the pictures we draw, even the music, then what is the thing underneath that makes me me? With respect and gratitude to him, who put this concept into words in an age with no AI in it. Who is the ghost?

The lyrics and the full liner notes are linked below.`,
  },

  // 「2026.08.20 リリックビデオ公開予定」は 2026-08-15 に外した [酒井]——日程に間に合わず、
  // 過ぎた予定を載せたままにすると古びて見えるため。**MV 自体は実在する**（AI の像がリップシンク
  // する映像）。公開先が未定なだけで、YouTube の独自チャンネルができたら日付を入れて戻す
  // （→ ../../../ARTIST.md「プロフィール請求の状況」・PURPOSE.md 未解決10）。
  timeline: [
    {
      date: "2026.08.08",
      ja: { event: "Who is the machine? 配信開始", description: "全主要配信プラットフォームにてリリース。Spotify・Apple Music・YouTube Musicほか各サービスで配信中。" },
      en: { event: "Who is the machine? released", description: "Out on all major streaming platforms — Spotify, Apple Music, YouTube Music and others." },
    },
    {
      date: "2026.08.10",
      ja: { event: "ライナーノーツ特設サイト公開", description: "歌詞とライナーノーツを収録した特設サイトを公開。制作の裏側をアーティスト自身の言葉で綴る。" },
      en: { event: "Liner notes site launched", description: "A dedicated site carrying the lyrics and the liner notes, with the story behind the song in the artist’s own words." },
    },
  ],

  // SNS アカウントは持っていない [酒井 2026-08-11]。
  // **ここに URL を足せば Footer のアイコンが自動で復活する**（値のあるものだけ描画される）。
  // 例: youtube: "https://www.youtube.com/@..."
  snsLinks: {} as Record<string, string>,

  credit: {
    // ⚠ credits.md では「アートワーク未定」。サイト側の記述が先行している。
    artDirection: "AI x HUMAN COLLAB",
    photography: "GENERATIVE AI ART",
  },
} as const;
